import React from 'react';
import columns from './columns';
import PreviewStepBase from '../../base/PreviewStepBase';
import { ASSET_ALIAS_FIELD, useCsvPreviewDataSource } from '../../base/useCsvPreviewDataSource';

export interface FindingPreviewStepProps {
  mapping: Record<string, string>;
  csvTopLines: string[][];
}

const FindingPreviewStep: React.FC<FindingPreviewStepProps> = ({ mapping, csvTopLines }) => {
  const columnsFields = React.useMemo(() => Object.values(columns).map((col) => col.dataField), []);

  const dataSource = useCsvPreviewDataSource(
    mapping,
    csvTopLines,
    columnsFields,
    {
      field: 'status',
      value: 'New',
    },
    ASSET_ALIAS_FIELD,
  );

  return (
    <PreviewStepBase
      infoText={
        <>
          Here is a preview of how your new findings will look like in the Findings Table. You can
          go back and edit your columns if needed before submitting.
        </>
      }
      dataGridId="finding-data-import-preview"
      pluralText="Findings"
      singularText="Finding"
      columns={columns}
      dataSource={dataSource}
    />
  );
};

export default React.memo(FindingPreviewStep);
